import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  toggle(ev) {
    ev.preventDefault()
    const check = this.checkboxTargets[ev.currentTarget.dataset.idx]
    check.checked = !check.checked

    if (check.checked) {
      $(ev.currentTarget)
        .removeClass("btn-outline-pink")
        .addClass("btn-pink")
    } else {
      $(ev.currentTarget)
        .addClass("btn-outline-pink")
        .removeClass("btn-pink")
    }
  }
}
